import { axiosHttpClientAdapter } from 'infra/adapters';
import { MessageSchedulerHttpGateway } from './MessageSchedulerHttpGateway';

export const messageSchedulerHttpGateway =
  new MessageSchedulerHttpGateway(axiosHttpClientAdapter);
